import React from 'react';
import { Helmet } from 'react-helmet';
import Section1 from './Section1';
import Section2 from './Section2';
import Section4 from './Section4';
import Section5 from './Section5';
import Section3_ny from './Section3-ny';
import Section3_ny_ny from './Section3-ny-ny';
import Section6 from './Section6';
import Section7 from './Section7';
import Section8 from './Section8';
import Section9_ny from './Section9-ny';
import Section10 from './Section10';
import Section11 from './Section11';

export default function ShopifyPlus_Texas() {
  return (
    <div className="ShopifyPlus pt-[160px] sm:pt-0">
      <Helmet>
        <title> Shopify Plus Development Company in Texas | Mean3</title>
        <meta
          name="description"
          content="Partner with Mean3, a trusted Texas Shopify Plus agency delivering scalable development, custom design & advanced integrations."
        />
      </Helmet>

      <Section1 />
      <Section2 />
      <Section4 />
      <Section5 />
      <Section3_ny />
      <Section3_ny_ny />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section9_ny />
      <Section10 />
      <Section11 />
    </div>
  );
}
